export { TrainingSimulationVoiceLive } from './TrainingSimulationVoiceLive';
export type { TrainingSimulationVoiceLiveProps } from './TrainingSimulationVoiceLive';
